import script from "./OrdersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdersPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrdersPage.vue?vue&type=style&index=0&id=9feeb284&lang=scss"

const __exports__ = script;

export default __exports__